<template>
  <div class="section">
    <div class="section_slide-two">
      <div class="container-fluid h-100">
        <div class="innerSection h-100">
          <div class="container">
            <div class="row upperRow justify-content-center">
              <div class="col-lg-3 col-md-4 col-sm-6" v-for="block in this.facts.blocks" :key="'A'+block">
                <div class="innerMain">
                  <div class="image_sections">
                    <div class="image_section" v-html="block.svg"></div>
                  </div>
                  <div class="small_heading">
                    <h4 class="text-white">{{block.title}}</h4>
                  </div>
                  <div class="main_content">
                    <ul class="text-white">
                      <li v-for="text in block.desc" :key="'B'+text">{{text}}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap';
export default {
    props:{
        facts:Object
    },
  methods: {
    boxes() {
    
    let columnBox = document.querySelectorAll(".innerMain");
    
    columnBox.forEach(( block )=>{

        block.addEventListener('mouseenter',function(){
           gsap.to(block ,{height : "100%"  , ease : 'power4.out' } , '-=.6');
        });
        
        block.addEventListener('mouseleave',function(){
          gsap.to(block ,{height : 0 ,  ease : 'power4.out'} , '-=.3');
        });
    })


      // let timeLine = gsap.timeline({
      //   scrollTrigger: {
      //     trigger: ".upperRow .col-lg-3",
      //     toggleActions: "play restart restart restart ",
      //   },
      // });
      // timeLine.fromTo(
      //   ".upperRow .col-lg-3",
      //   { y: "100%", autoAlpha: 0 },
      //   { y: 0, autoAlpha: 1, stagger: 0.2, duration: 0.5 }
      // );
    },
  },
  mounted() {
    this.boxes();
  },
};
</script>

<style lang="scss" scoped></style>
